import React from 'react';
import ReactDOM from 'react-dom';
import CartItem from './CartItem';

const CartItemList = (props) => {

    let cart = localStorage.getItem('cartData');
    let cartData = JSON.parse(cart);
    var cartItems = Object.keys(cartData).map(function(key) {
        return [key, cartData[key]];
    });

    return (
        cartItems.map(post2 => {
            let cartITEM = post2[0].split('~~**~~');
            let itemCOUNT = post2[1];

            let itemID = cartITEM[0];
            let itemCUSTOM = cartITEM[1];
            //console.log(post2);
            return( <CartItem key={post2} item={props.items} itemID={itemID} itemCUSTOM={itemCUSTOM} itemCOUNT={itemCOUNT} updateCart2={props.updateCart} />);
        })
    );
}
  
export default CartItemList;


// WEBPACK FOOTER //
// ./src/components/CartItemList.js